import { Component, Inject, Injector, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../base.component';
import { OrganizationInterface } from 'app/core/interfaces/organization';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { OrganizationInfoDialogComponent } from '../organization-info-dialog/organization-info-dialog.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';
import { UtilsService } from '../../utils.service';
import { friendlyProcedureName } from '../../models/schedule-search.models';
import { summarizeSchedulePayment } from '../../models/schedule-payment-summary';

@Component({
  selector: 'shedule-organization-dealer',
  templateUrl: './shedule-organization-dealer.component.html',
  styleUrls: ['./shedule-organization-dealer.component.css']
})
export class SheduleOrganizationDealerComponent extends BaseComponent{

  @Input() organization ?: OrganizationInterface;
  @Input() healthcareservice ?: Healthcareservice
  @Input() location ?: any;
  @Input() index: number = 0;

  constructor(
    private locationService: OrganizationLocationService,
    private inject: Injector,
    private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { 
    super(inject)
  }

  ngOnInit(): void {

  }

  getOrganizationPhoto() {
    const url = this.organization?.photo || this.defaultOrganizationPhoto;
    return url;
  }

  getLocation(): string {
    const address = this.location?.address ?? this.location;
    const addressLine = [address?.street, address?.number].filter(Boolean).join(', ');
    const cityLine = [address?.city, address?.state].filter(Boolean).join('-');
    return [addressLine, cityLine].filter(Boolean).join(', ') || 'Localização não informada';
  }

  getProcedureDisplayName(): string {
    return friendlyProcedureName(this.healthcareservice?.name);
  }

  getPaymentSummary(): string | null {
    return summarizeSchedulePayment(this.healthcareservice ? [this.healthcareservice] : []).compactLabel;
  }

  openGoogleMapsLocation() {
    const mapUrl = this.location?.mapUrl;
    if (mapUrl) window.open(mapUrl, '_blank', 'noopener,noreferrer');
  }

  openOrganizationInfos() {
    
    const data = {
      param: {
        organization: this.organization,
        organizationLocation: this.location,
      },
    };

    this.dialog.openComponentDialog(OrganizationInfoDialogComponent, data);
  }

  public toggleHorarios(index?: number) {
    this.utilsService.toggleHorarios(index);    
  }

}
